import { FlatInjectionObj, InjectionsEntity } from '../store/types/prescription';

export const getInjectionFlatArray = (elements: InjectionsEntity[]): FlatInjectionObj[] => {
    const flatArray = elements.reduce((accumulator, element, currentIndex): FlatInjectionObj[] => {
        accumulator.push({
            ...element,
            mainIndex: currentIndex,
            currentIndex: 0,
            is_last_drug: !(element.added_drug && element.added_drug.length > 0),
            is_last_tapering: !(element.tapering_dose && element.tapering_dose.length > 0),
        });
        element.tapering_dose?.forEach((tapering_value, tapering_index, array) => {
            accumulator.push({
                ...tapering_value,
                mainIndex: currentIndex,
                currentIndex: tapering_index,
                is_tapering_dose: true,
                is_last_tapering: array.length - 1 === tapering_index,
            } as FlatInjectionObj);
        });

        element.added_drug?.forEach((value, index, array) => {
            accumulator.push({
                ...value,
                mainIndex: currentIndex,
                currentIndex: index,
                is_last_drug: array.length - 1 === index,
                is_added_drug: true,
            } as FlatInjectionObj);
        });
        return accumulator;
    }, [] as FlatInjectionObj[]);

    return flatArray;
};
